const $ = require('jquery')

$.noConflict()

$(document).ready(function() {
  $('form[data-wffm]').each(function() {
    $(this).wffmForm()
  })
})



// WEBPACK FOOTER //
// ./src/wffm/main.js